<template>
    <div class="button_row">
        <div v-if="showIcons" v-click-outside="hideIcons" class="share_wrapper">
            <div class="share_list flex">
                <a class="link" @click="copyToClipboard">
                    <picture v-full-image-path:assets="'icon_share_link.svg'" />
                </a>

                <a
                    class="link"
                    :href="`https://www.facebook.com/sharer/sharer.php?u=${link}`"
                    target="_blank"
                >
                    <picture
                        v-full-image-path:assets="'icon_share_facebook.svg'"
                    />
                </a>

                <a
                    class="link"
                    :href="`https://api.whatsapp.com/send?text=${link}`"
                    target="_blank"
                >
                    <picture
                        v-full-image-path:assets="'icon_share_whatsapp.svg'"
                    />
                </a>

                <a
                    class="link"
                    :href="`mailto:?subject=${mailSubject}&body=${link}`"
                    target="_blank"
                >
                    <picture v-full-image-path:assets="'icon_share_mail.svg'" />
                </a>
            </div>
        </div>

        <button
            v-else
            type="button"
            class="btn_reset btn_sharing"
            @click="showIcons = true"
        >
            {{ $t('general.share') }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            showIcons: false
        };
    },

    computed: {
        link() {
            const baseUrl = window.location.href;

            return baseUrl;
        },

        mailSubject() {
            return this.item.title;
        }
    },

    methods: {
        copyToClipboard() {
            navigator.clipboard.writeText(this.link);

            this.$toasted.success(this.$t('general.copyLinkToClipboardText'));
        },

        hideIcons() {
            this.showIcons = false;
        }
    }
};
</script>
